import { forwardRef } from "react"

import { Col } from "@/atoms"
import { LinkCard } from "../../molecules/LinkCard"

import type { StatisticCardTemplateProps } from "."

const StatisticCardTemplate = forwardRef<
  HTMLDivElement,
  StatisticCardTemplateProps
>((props, ref) => {
  const { children, footer, to, selected, className, ...rest } = props

  return (
    <Col ref={ref} {...rest}>
      <LinkCard to={to} selected={selected} className={className}>
        {children}
      </LinkCard>
      {!!footer && footer}
    </Col>
  )
})

StatisticCardTemplate.displayName = "StatisticCardTemplate"

export default StatisticCardTemplate
